module.exports = __webpack_public_path__ + "static/img/移动应用.b4ff1bd2.png";